/**
 * Validation result types for payslip CSV import.
 * Used by csvValidator to return structured errors.
 */

export type ValidationErrorKind = "format" | "columns" | "row";

export interface ValidationError {
  kind: ValidationErrorKind;
  /** 1-based row number (0 = header/format level) */
  row: number;
  /** Column name or empty for format/column-level errors */
  column: string;
  message: string;
}

export type ValidationStatus = "valid" | "invalid";

export interface ValidationResult {
  status: ValidationStatus;
  errors: ValidationError[];
  /** Number of data rows parsed (excluding header) */
  rowCount: number;
}

export function createValidationResult(
  status: ValidationStatus,
  errors: ValidationError[],
  rowCount: number,
): ValidationResult {
  return { status, errors, rowCount };
}

export function createValidationError(
  kind: ValidationErrorKind,
  row: number,
  column: string,
  message: string,
): ValidationError {
  return { kind, row, column, message };
}
